export default "__VITE_ASSET__Br0geIF0__"